import React from "react";
import { AnimateIn } from "./AnimateIn";
import HeroBioCanvas from "./HeroBioCanvas";
import "./Header.css";

export const Header = ({ data }) => {
  if (!data) return null;

  return (
    <header id="header" className="hero-section">
      <div className="hero-bg" />
      <HeroBioCanvas />
      <div className="hero-content">
        <AnimateIn variant="fadeUp" duration={0.8}>
          <p className="hero-eyebrow">{data.eyebrow}</p>
        </AnimateIn>
        <AnimateIn variant="fadeUp" delay={0.1} duration={0.8}>
          <h1 className="hero-title">
            {data.title}
          </h1>
        </AnimateIn>
        <AnimateIn variant="fadeUp" delay={0.2} duration={0.8}>
          <p className="hero-description">{data.description}</p>
        </AnimateIn>
        <AnimateIn variant="fadeUp" delay={0.3} duration={0.8}>
          <div className="hero-actions">
            <a className="hero-cta-primary" href="#products">
              {data.ctaSecondary} →
            </a>
            <a className="hero-cta-secondary" href={data.ctaUrl || "https://medi-lens.ai/register-demo"} target="_blank" rel="noopener noreferrer">
              {data.ctaPrimary}
            </a>
          </div>
        </AnimateIn>
        <div className="hero-scroll-hint">
          <p>スクロールして詳細を見る</p>
          <span className="hero-scroll-arrow">↓</span>
        </div>
      </div>
    </header>
  );
};
